import { RECEIVE_BANK_ACCOUNT, REQUEST_BANK_ACCOUNT } from '../actions'

export default (
    state = {
        fetchSuccessful: null,
        shouldFetch: true,
    },
    action
) => {
    const { type, data } = action

    switch (type) {
        case REQUEST_BANK_ACCOUNT:
            return { ...state, shouldFetch: false }

        case RECEIVE_BANK_ACCOUNT:
            return { ...state, ...data }

        default:
            return state
    }
}
